// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"styles__Wrapper___1RyMV","Container":"styles__Container___2poHB","LeftSide":"styles__LeftSide___3FyuD","LeftSideTitle":"styles__LeftSideTitle___3gVEn","LeftSideDescription":"styles__LeftSideDescription___3ALss","LeftSideLaptop":"styles__LeftSideLaptop___1jF8P","LeftSideLaptopImg":"styles__LeftSideLaptopImg___2AQfq","LeftSideStores":"styles__LeftSideStores___NjyVj","RightSide":"styles__RightSide___2iKkD","MobileLogo":"styles__MobileLogo___3_8_Y","RightSideFooter":"styles__RightSideFooter___1jXcG","RightSideFooterLinks":"styles__RightSideFooterLinks___1Pyn6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/styles.scss
// module id = 1474
// module chunks = 0